import React from 'react';
import PropTypes from 'prop-types';
import { ContentWrap } from './../Components/ShowMoreTotalAdminFee/styles.js';

const TransactionDetailsFootnotes = ({ footnotes }) => {
    return (
        <div data-test="transaction-details-footnotes">
            <ContentWrap marginBottom="0" paddingBottom="3px" dangerouslySetInnerHTML={{ __html: footnotes }}>
            </ContentWrap>
        </div>
    )
}

TransactionDetailsFootnotes.propTypes = {
    footnotes: PropTypes.string
}
export default TransactionDetailsFootnotes;